






















import Vue from 'vue';
import { Component, Inject } from 'vue-property-decorator';

@Component
export default class Money extends Vue {
    @Inject() eventBus!: Vue;
    balance = 0;
    switch = false;

    get isSwitch() {
        return this.switch;
    }
    created() {
        this.eventBus.$on('updateBalance',
            (balance: number) => this.balance = balance);
    }
    mounted(){
        this.eventBus.$on('updateSwitch',
            () => this.switch = !this.switch);
    }
}
